import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ShellTrackHandlers } from '@cigna/chcp/shared/analytics-util';
import { DialogVideoEmbedComponent } from '@cigna/chcp/shared/ui';
import { DialogWhatIsTempIdComponent } from '../dialog-what-is-temp-id/dialog-what-is-temp-id.component';

import { AuthService } from '@auth0/auth0-angular';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, startWith, map } from 'rxjs';

@Component({
  selector: 'cigna-login-form-auth0',
  templateUrl: './login-form-auth0.component.html',
  styleUrls: ['./login-form-auth0.component.scss'],
})
export class LoginFormAuth0Component {
  hasWam = true;
  authError$ = this.auth.error$;

  isAuthLoading$ = combineLatest([
    this.activatedRoute.queryParams,
    this.auth.isLoading$.pipe(startWith(false)),
    this.authError$.pipe(startWith(null)),
  ]).pipe(
    map(
      ([params, isLoading, isError]) =>
        (isLoading ||
          (params.code !== undefined && params.state !== undefined)) &&
        !isError,
    ),
  );

  constructor(
    private analytics: ShellTrackHandlers,
    public dialog: MatDialog,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
  ) {}

  loginAuth0() {
    this.auth.loginWithRedirect({
      appState: {
        target: '/dashboard',
      },
    });
  }

  openWhatIsTemporaryIdModal() {
    this.dialog.open(DialogWhatIsTempIdComponent, {
      autoFocus: false,
      width: '600px',
    });
  }

  openHowToRegisterModal() {
    this.dialog.open(DialogVideoEmbedComponent, {
      autoFocus: false,
      width: '900px',
      data: {
        title: 'How to register',
        id: '6f82d46ea8f0476096a7df762d490bb1',
        player: 'limelight',
        width: 800,
        height: 475,
      },
    });
  }
}
